import Box from "@mui/material/Box";
import { Formik, Form, FormikValues } from "formik";
import styles from "./styles.module.scss";
import { logger } from "../../../utils/logger";
import SearchField from "../../common/Search/Search";
import { FormControl, InputAdornment, OutlinedInput } from "@mui/material";
import { Add, PlusOne, Search } from "@mui/icons-material";
// import UserListTable from "./UserListTable";
import SaveButton from "../../common/Button";
import { useState, useEffect } from "react";
import departmentService from "../../../services/department";
import DepartmentListTable from "./DepartmentListTable";
import { RootState, useAppDispatch } from "../../../redux/store";
import { setLoadingAction } from "../../../redux/utils/actions";
import { shallowEqual, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export type IDepartment = {
  _id: string;
  name: string;
  expiresIn: number;
  maxAmount: number;
  timeType: string;
  expiresOn: string;
  isEditOpened: boolean;
};

export default function Department() {
  const navigate = useNavigate();
  const [gridData, setGridData] = useState<IDepartment[]>([]);
  const dispatch = useAppDispatch();
  const loading = useSelector(
    (state: RootState) => state.utils.loading,
    shallowEqual
  );

  const getData = async () => {
    try {
      dispatch(setLoadingAction(true));
      const { data } = await departmentService.getAll();
      dispatch(setLoadingAction(false));
      const modifiedData = data.data.map((item: any) => ({
        ...item,
        isEditOpened: false,
      }));
      setGridData(modifiedData);
    } catch (err) {
      logger.error(err);
      dispatch(setLoadingAction(false));
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Box className={styles.sidebarStyle}>
        <Box className="d-flex align-items-center justify-content-between mg-b-10">
          <h1 className={`${styles.titleButton} mg-r-10`}>Department</h1>

          <Box sx={{ display: "flex", gap: "10px" }}>
            <SaveButton
              color="alert"
              onClick={() => navigate("/department/add")}
              type="submit"
            >
              Add
            </SaveButton>
          </Box>
        </Box>
        <Box>
          <DepartmentListTable
            gridData={gridData}
            setGridData={setGridData}
            getData={getData}
          />
        </Box>
      </Box>
    </>
  );
}
